export default "__VITE_ASSET__BKcMtxUS__";